import { Flex, Input, Typography } from "antd";
import { useEffect, useState } from "react";

const InputMask = ({ value, field, onKeyDown, onChange, onValidate }) => {
  const [val, setVal] = useState(value);
  const [error, setError] = useState(null);

  const validateValue = (nextValue) => {
    const regexpKey = field?.regexp;

    if (!regexpKey || !nextValue) {
      setError(null);
      onValidate?.(true);
      return true;
    }

    try {
      const regexp = new RegExp(regexpKey);
      const isValid = regexp.test(nextValue);

      setError(
        isValid ? null : `Значение не соответствует маске: ${field?.example}`,
      );

      onValidate?.(isValid);

      return isValid;
    } catch {
      setError("Некорректная маска поля");
      onValidate?.(false);
      return false;
    }
  };

  useEffect(() => {
    setVal(value);
    validateValue(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, field?.regexp]);

  const handleChange = (e) => {
    const nextValue = e.target.value;

    setVal(nextValue);
    validateValue(nextValue);
    onChange?.(nextValue);
  };

  return (
    <Flex vertical gap={5}>
      <Input
        value={val}
        placeholder={field?.example || ""}
        status={error ? "error" : ""}
        className="w-100"
        onChange={handleChange}
        onKeyDown={(e) => {
          const isValid = validateValue(val);

          if (!isValid && e.key === "Enter") {
            e.preventDefault();
            return;
          }

          onKeyDown?.(e, val);
        }}
      />

      {error && (
        <Typography.Text type="danger" style={{ fontSize: 12 }}>
          {error}
        </Typography.Text>
      )}
    </Flex>
  );
};

export default InputMask;
